import { chatApi } from '@/store/api/conversation/chat/chat.api';
import { writeChatPresence } from '@/store/api/conversation/chat/chat.cache';
import { type TypeChannelOnly, chatGroupApi } from '@/store/api/conversation/chat/chat.group.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeChatMember, TypeChatPresenceUpdate } from '@/types/conversation/types.conversation.chat.channel';

const EMPTY_UNREAD = { count: 0, firstUnreadId: null, mentionIds: [] };

export const upsertChatChannel = (dispatch: TypeAppDispatch, incoming: TypeChannelOnly, members: TypeChatMember[] = []) => {
    dispatch(chatApi.util.updateQueryData('listChatChannels', undefined, (draft) => {
        const index = draft.channels.findIndex((entry) => entry.id === incoming.id);
        if (index >= 0) {
            const current = draft.channels[index];
            draft.channels[index] = { ...current, ...incoming, lastMessageAt: incoming.lastMessageAt && (!current.lastMessageAt || incoming.lastMessageAt > current.lastMessageAt) ? incoming.lastMessageAt : current.lastMessageAt };
        } else {
            draft.channels.push({ ...incoming, lastReadAt: incoming.lastMessageAt, archivedAt: null, mutedUntil: null, unread: { ...EMPTY_UNREAD }, lastMessage: null });
        }
        for (const member of members) {
            const at = draft.members.findIndex((entry) => entry.id === member.id);
            if (at >= 0) draft.members[at] = member;
            else draft.members.push(member);
        }
    }));
};

export const removeChatChannel = (dispatch: TypeAppDispatch, id: string) => {
    dispatch(chatApi.util.updateQueryData('listChatChannels', undefined, (draft) => {
        draft.channels = draft.channels.filter((entry) => entry.id !== id);
    }));
};

export const applyChatPresence = (dispatch: TypeAppDispatch, update: TypeChatPresenceUpdate) => {
    writeChatPresence(dispatch, update);
    dispatch(chatGroupApi.util.updateQueryData('listChatPeople', undefined, (draft) => {
        const person = draft.find((entry) => entry.id === update.userId);
        if (!person) return;
        person.presence = update.presence;
        if (update.lastSeenAt && (!person.lastSeenAt || person.lastSeenAt < update.lastSeenAt)) person.lastSeenAt = update.lastSeenAt;
    }));
};
